jQuery(function(){
  useLogoReplace()
  useExpandMenu()
  useHeaderAccordionMenu()
  useFooterAccordionMenu()
  useNewsCategoryAccordionMenu()
  useModal()
})

function useLogoReplace() {
  const header = document.querySelector('.header')
  if (!header) return

  const logoElement = header.querySelector('.header__logo img')
  const logoInfo = {
      el: logoElement,
      off: logoElement.src,
      on: logoElement.src.replace('_white', '_black')
  }

  header.addEventListener('mouseenter', e => {
    logoInfo.el.src = logoInfo.on
  })
  header.addEventListener('mouseleave', e => {
    logoInfo.el.src = logoInfo.off
  })
}

function useExpandMenu() {
  const menuExpandTriggers = document.querySelectorAll('.header__menu-expand-trigger')
  let currentTriggerElement = undefined
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(item => {
    item.addEventListener('mouseover', e => {
      if (currentTriggerElement !== undefined) {
        currentTriggerElement.nextElementSibling.classList.remove('expanded')
        currentTriggerElement.parentNode.classList.remove('active')
      }
      item.nextElementSibling.classList.add('expanded')
      item.parentNode.classList.add('active')
      currentTriggerElement = item
    })
  })
  const menuExpandBody = document.querySelectorAll('.header__menu-expand')
  Array.prototype.slice.call(menuExpandBody, 0).forEach(item => {
    item.addEventListener('mouseleave', e => {
      item.classList.remove('expanded')
      item.parentNode.classList.remove('active')
      currentTriggerElement = undefined
    })
  })
  document.body.addEventListener('mouseleave', e => {
    Array.prototype.slice.call(menuExpandBody, 0).forEach(item => {
      item.classList.remove('expanded')
      item.parentNode.classList.remove('active')
    })
    currentTriggerElement = undefined
  })
}

function useHeaderAccordionMenu() {
  const menuBodyTrigger = document.querySelector('.header__menu-toggle')
  const menuBody = document.querySelector('.header__menu-accordion')
  if (!menuBodyTrigger) return

  const logoElement = header.querySelector('.header__logo img')
  const logoInfo = {
      el: logoElement,
      off: logoElement.src,
      on: logoElement.src.replace('_white', '_black')
  }

  menuBodyTrigger.addEventListener('click', e => {
    if (menuBody.classList.contains('open')) {
      menuBody.classList.remove('open')
      document.querySelector('body').classList.remove('no-scroll')

      const parts = menuBody.querySelectorAll('.accordion-part')
      Array.prototype.slice.call(parts, 0).forEach(item => {
        if (item.classList.contains('open')) {
          item.classList.remove('open')
          item.classList.add('closed')
        }
      })

      if (window.scrollY == 0) {
        document.querySelector('.header').classList.remove('invert')
        logoInfo.el.src = logoInfo.off
      }
    } else {
      menuBody.classList.add('open')
      document.querySelector('body').classList.add('no-scroll')
      document.querySelector('.header').classList.add('invert')
      logoInfo.el.src = logoInfo.on
    }
    e.preventDefault()
  })

  const menuExpandTriggers = menuBody.querySelectorAll('.accordion-bellows-control')
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(item => {
    item.addEventListener('click', e => {
      const target = item.parentNode.parentNode
      if (target.classList.contains('closed')) {
        target.classList.remove('closed')
        target.classList.add('open')
      } else {
        target.classList.remove('open')
        target.classList.add('closed')
      }
    })
  })


  let ticking = false
  window.addEventListener('scroll', e => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
      if (window.innerWidth > 768) return
      if (window.scrollY > 0) {
        document.querySelector('.header').classList.add('invert')
        logoInfo.el.src = logoInfo.on
      } else {
        document.querySelector('.header').classList.remove('invert')
        logoInfo.el.src = logoInfo.off
      }
      ticking = false
      })
      ticking = true
    }
  })
}

function useFooterAccordionMenu() {
  const menuExpandTriggers = document.querySelectorAll('dt.accordion')
  if (!menuExpandTriggers) return
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(item => {
    item.addEventListener('click', function(e) {
      item.classList.toggle('closed')
    })
  })
}

function useNewsCategoryAccordionMenu() {
  const menuBody = document.querySelector('.news__category-accordion')
  if (!menuBody) return
  const menuExpandTriggers = menuBody.querySelectorAll('.accordion-bellows-control')
  Array.prototype.slice.call(menuExpandTriggers, 0).forEach(item => {
    item.addEventListener('click', e => {
      const target = item.parentNode.parentNode
      if (target.classList.contains('closed')) {
        target.classList.remove('closed')
        target.classList.add('open')
      } else {
        target.classList.remove('open')
        target.classList.add('closed')
      }
    })
  })
}

function useModal() {
  const modalElement = document.getElementById('modal')
  if (!modalElement) return
  const modal = new RModal(
    modalElement,
    {
      dialogOpenClass: 'animated fadeIn',
      dialogCloseClass: 'animated fadeOut',
      afterClose: function () {
        modalElement.querySelector('.modal-content').textContent = null
        modalElement.querySelector('.modal-dialog').classList.remove('fadeIn', 'fadeOut', 'animated')
      }
    }
  )

  modalElement.addEventListener('click', e => {
    modal.close()
  })

  document.addEventListener('keydown', e => {
    modal.keydown(e)
  }, false)

  const modalOpenTriggers = document.querySelectorAll('.show-movie-modal')
  Array.prototype.slice.call(modalOpenTriggers, 0).forEach(item => {
    const isYoutube = item.classList.contains('youtube')
    item.addEventListener('click', e => {
      e.preventDefault()
      if (isYoutube) {
        const matches = item.href.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)
        if (matches && matches[2].length == 11) {
          const modalContentYoutube = document.createElement('div')
          modalContentYoutube.classList.add('modal-content-youtube')
          const iframeWrapper = document.createElement('div')
          modalContentYoutube.appendChild(iframeWrapper)
          const iframe = document.createElement('iframe')
          iframe.width = 510
          iframe.height = 287
          iframe.src = `https://www.youtube.com/embed/${matches[2]}?rel=0`
          iframe.setAttribute('playsinline', 1)
          iframe.setAttribute('frameborder', 0)
          iframeWrapper.appendChild(iframe)
          modalElement.querySelector('.modal-content').appendChild(modalContentYoutube)
        }
      } else {
        const video = document.createElement('video')
        video.src = item.href
        video.controls = 'controls'
        video.setAttribute('playsinline', 'playsinline')
        video.addEventListener('loadeddata', e => {
          modalElement.querySelector('.modal-content').appendChild(video)
        })
      }
      modal.open()
    })
  })

  window.modal = modal
}



// WEBPACK FOOTER //
// ./assets/js/base.js